import { get_auth_key, get_master_auth_key, storeData } from './index';

export const signOutClearLocalStorage = () => {
  const masterAuthKey = get_master_auth_key();
  const authKey = get_auth_key();
  localStorage.removeItem(masterAuthKey);
  localStorage.removeItem(authKey);
};
